var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-icon-box",class:[
    { 'has-bg': _vm.backgroundColor || _vm.backgroundClass },
    _vm.backgroundColor ? '' : _vm.backgroundClass,
    _vm.layout,
  ],style:(_vm.backgroundColor ? `backgroundColor: ${_vm.backgroundColor}` : '')},[_c('div',{staticClass:"feature-icon-box-content",class:{ 'no-icon': !_vm.hasMain?.fileData }},[(_vm.hasMain?.fileData)?_c('ContentGeneratorElementsMedia',{staticClass:"feature-icon-box-icon",attrs:{"aspect-ratio-mobile":"1/1","aspect-ratio":"1/1","value":_vm.content.media}}):_vm._e(),_vm._v(" "),_c('ContentGeneratorElementsText',{attrs:{"content":_vm.content.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }